import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AnimatedBackground from '../components/AnimatedBackground';
import ArticleStructuredData from '../components/ArticleStructuredData';
import LawFirmsHeader from '../components/LawFirmsHeader';
import { fireEvent } from '../utils/funnelEvents';

import LawFirmsHero from './law-firms/LawFirmsHero';
import Workflow from './law-firms/Workflow';
import PainPoints from './law-firms/PainPoints';
import DataHandling from './law-firms/DataHandling';
import ClioIntegration from './law-firms/ClioIntegration';
import LawFirmsAnswers from './law-firms/LawFirmsAnswers';
import LawFirmsPricing from './law-firms/LawFirmsPricing';
import LawFirmsFAQ from './law-firms/LawFirmsFAQ';
import ContactInfo from './law-firms/ContactInfo';
import ResearchInviteCard from '../components/research/ResearchInviteCard';

// Mirrored in scripts/generate-snap-routes.js STATIC_META['/for-law-firms'],
// which is what the prerendered HTML (and link previews) carry. Change both.
const PAGE_TITLE = 'Law Firm Document Filing by Client and Matter | Sortio';
const PAGE_DESCRIPTION =
  "With Analyze contents on, Sortio reads each document, even scans, finds the client and the matter, and renames each file your firm's way. Nothing moves until you click Apply. Free trial for Mac & Windows.";

const LawFirmsPage = () => {
  useEffect(() => {
    fireEvent('team_page_view', { vertical: 'law-firms' });
  }, []);

  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESCRIPTION} />
        <meta
          name="keywords"
          content="law firm document filing, file documents by client and matter, paralegal document filing, rename scanned legal documents, OCR scanned PDFs, legal document organizer for Mac and Windows, Clio document filing"
        />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESCRIPTION} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.getsortio.com/for-law-firms" />
        <link rel="canonical" href="https://www.getsortio.com/for-law-firms" />
      </Helmet>
      <ArticleStructuredData
        title={PAGE_TITLE}
        description={PAGE_DESCRIPTION}
        datePublished="2026-05-05T00:00:00.000Z"
        dateModified="2026-10-01T00:00:00.000Z"
        authorName="Sortio Team"
      />

      <LawFirmsHeader />
      <LawFirmsHero />

      <div className="relative">
        <AnimatedBackground variant="business" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
          <Workflow />
          <PainPoints />
          <DataHandling />
          <ClioIntegration />
          <LawFirmsAnswers />
          <LawFirmsPricing />
          <LawFirmsFAQ />
          <ResearchInviteCard vertical="legal" />
          <ContactInfo />
        </div>
      </div>
    </>
  );
};

export default LawFirmsPage;
